import { c as _c } from "react/compiler-runtime";
import type { InterfaceToken } from '@morpho-org/dapp-core';
import { ZERO } from '@morpho-org/dapp-core';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { memo, useMemo } from 'react';
interface VaultV2AllocationCellProps {
  amount: bigint;
  token: InterfaceToken | null | undefined;
}
function VaultV2AllocationCell(t0) {
  const $ = _c(13);
  const {
    amount,
    token
  } = t0;
  let t1;
  if ($[0] !== amount || $[1] !== token?.decimals) {
    t1 = formatters.short.default("0").trailingZero(false).digits(2).of(amount, token?.decimals);
    $[0] = amount;
    $[1] = token?.decimals;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formattedAllocation = t1;
  let t2;
  if ($[3] !== amount || $[4] !== token) {
    const usdValue = token?.toUsd(amount) ?? ZERO;
    t2 = formatters.short.default("0").trailingZero(false).digits(2).unit("$").of(usdValue, 18);
    $[3] = amount;
    $[4] = token;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const formattedAllocationUsd = t2;
  let t3;
  if ($[6] !== formattedAllocation) {
    t3 = <TooltipTrigger asChild={true}><span className="text-2xs text-foreground">{formattedAllocation}</span></TooltipTrigger>;
    $[6] = formattedAllocation;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== formattedAllocationUsd) {
    t4 = <TooltipContent>{formattedAllocationUsd}</TooltipContent>;
    $[8] = formattedAllocationUsd;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <Tooltip>{t3}{t4}</Tooltip>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export default memo(VaultV2AllocationCell);